import { useEffect, useState } from "react";
import { toast } from "sonner";
import { WifiOff, RefreshCw } from "lucide-react";
import { readQueue, syncQueue } from "../lib/offlineQueue";
import { useLang } from "../context/LangContext";

export default function OfflineBanner() {
  const { t } = useLang();
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(readQueue().length);
  const [syncing, setSyncing] = useState(false);

  const sync = async () => {
    if (!navigator.onLine || !readQueue().length) return;
    setSyncing(true);
    const r = await syncQueue();
    setSyncing(false);
    if (r.busy) return;
    setPending(r.remaining);
    if (r.synced) toast.success(`${r.synced} ${t("offline_synced")}`);
    (r.errors || []).forEach((e) => toast.error(`${e.item.payload.action === "out" ? "SORTIE" : "ENTREE"} ×${e.item.payload.quantity} : ${typeof e.detail === "string" ? e.detail : t("offline_rejected")}`));
    if (r.synced) window.dispatchEvent(new Event("movements-synced"));
  };

  useEffect(() => {
    const on = () => { setOnline(true); sync(); };
    const off = () => setOnline(false);
    const upd = () => setPending(readQueue().length);
    window.addEventListener("online", on); window.addEventListener("offline", off); window.addEventListener("offline-queue-changed", upd);
    sync();
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); window.removeEventListener("offline-queue-changed", upd); };
    // eslint-disable-next-line
  }, []);

  if (online && pending === 0) return null;
  return (
    <div data-testid="offline-banner" className={`px-4 py-2 text-xs flex items-center gap-2 justify-center ${online ? "bg-amber-500/15 text-amber-200" : "bg-rose-500/15 text-rose-200"}`}>
      {online ? <RefreshCw className={`w-3.5 h-3.5 ${syncing ? "animate-spin" : ""}`} /> : <WifiOff className="w-3.5 h-3.5" />}
      {online ? `${pending} ${t("offline_pending")}` : t("offline_mode")}
      {online && pending > 0 && <button data-testid="offline-sync-btn" onClick={sync} className="underline ml-1">{t("sync_now")}</button>}
    </div>
  );
}
